import React from "react";

const OrganicManicureBook = () => {
  return (
    <div className="nailSalonBookContainer">
      <h5>Book Your Organic Manicure Appointment Today!</h5>
      <p>
        Visit SCReady to experience the ultimate in eco-friendly nail care with
        our Organic Manicure? Book your appointment at SCENT  today and
        treat yourself to a luxurious pampering session. Our friendly and
        professional team is here to provide you with the best organic nail care
        services in Bangalore.
      </p>
      <p>
        Discover the beauty of an Organic Manicure at SCENT  and let us
        help you achieve healthy, beautiful nails while making a positive impact
        on the environment. We look forward to welcoming you to our salon and
        providing you with an exceptional nail care experience.
      </p>
    </div>
  );
};

export default OrganicManicureBook;
